import { render, staticRenderFns } from "./logo-nigeria.vue?vue&type=template&id=e9884c5a&scoped=true&"
import script from "./logo-nigeria.vue?vue&type=script&lang=js&"
export * from "./logo-nigeria.vue?vue&type=script&lang=js&"
import style0 from "./logo-nigeria.vue?vue&type=style&index=0&id=e9884c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9884c5a",
  null
  
)

export default component.exports